import { Controller } from "@hotwired/stimulus";

// Usage: data-controller="js-utils" data-action="click->js-utils#removeFirstOutreachMadeBanner"
export default class extends Controller {
  removeFirstOutreachMadeBanner(event) {
    if (event) event.preventDefault();
    const banner = document.getElementById("first-outreach-made");
    if (banner) banner.remove();
  }

  // Usage: data-action="click->js-utils#back"
  back(event) {
    if (event) event.preventDefault();
    window.history.back();
  }
}
